import React from 'react';
import { getTourPointAddress } from 'app/API/autocomplete';
import {
  SEARCH_BAR_ALL,
  SEARCH_BAR_MEMBER,
  SEARCH_BAR_PLACES,
  SEARCH_BAR_BIKER_BED,
  SEARCH_BAR_BIKE_CLUB,
  SEARCH_BAR_TOUR,
} from '../../../constants/mainSearch.constants';
import searchAPI from '../../../API/mainSearch.api';

const searching = [
  { value: 'Searching...', data: {}, isDisable: true, isLoading: true },
];

const cancel = () => {
  searchAPI.getTourByTitle();
  getTourPointAddress();
  searchAPI.getClubByTitle();
  searchAPI.getBikerBedByTitle();
  searchAPI.getPlacesByTitle();
  searchAPI.getMembersByName();
};

const loadTour = (val, roadTypes, setData) => {
  setData(searching);
  searchAPI.getTourByTitle(val, roadTypes, setData, SEARCH_BAR_TOUR);
};

const load = (val, scope, roadTypes, setData) => {
  if (!val) return;

  setData(searching);
  getTourPointAddress(val, setData, SEARCH_BAR_ALL);
  searchAPI.getTourByTitle(val, roadTypes, setData, SEARCH_BAR_TOUR);
  searchAPI.getClubByTitle(val, setData, SEARCH_BAR_BIKE_CLUB);
  searchAPI.getBikerBedByTitle(val, setData, SEARCH_BAR_BIKER_BED);
  searchAPI.getMembersByName(val, setData, SEARCH_BAR_MEMBER);
  searchAPI.getPlacesByTitle(val, setData, SEARCH_BAR_PLACES);
};

export const searchLoader = {
  load,
  loadTour,
  cancel,
};
